<template>
  <v-content>
    <v-container fluid>
      <v-layout row justify-center>
        <v-card class="mt-3 pa-3" color="green lighten-5">
          <v-card-text>
            <v-layout row justify-center>
              <div v-if="loading" class="display-1 my-3">Estamos activando tu correo electrónico...</div>
              <div v-else class="display-1 my-3">{{ clientName }}, tu correo electrónico ha sido activado.</div>
            </v-layout>
          </v-card-text>
          <v-card-text>
            <v-layout row justify-center>
              <v-progress-circular v-if="loading" indeterminate :size="100" color="primary"/>
              <v-icon v-else large color="green">check</v-icon>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'confirm-email',
  data: function () {
    return {
      loading: true
    }
  },
  computed: {
    clientName: function () {
      return this.$store.state.ConfirmEmail.clientName
    }
  },
  mounted: async function () {
    await this.$store.dispatch('ConfirmEmail/activateEmail', { token: this.$route.params.token })
    this.loading = false
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmEmail.vue